<template>
	<transition
			appear
			:appear-active-class="$_trnCrsShtLyt_stylePageLayoutAnimation()">
		<template v-if="initialized_">
			<v-row class="customVRow" no-gutters>
				<v-col>
					<template v-for="(courseVals, courseKey) in sortObject($_trnCrsShtLyt_stateTrainings, 'order')">
						<v-row :key="courseKey" no-gutters>
							<v-col>
								<v-row justify="center">
									<v-col cols="11" md="9">
										<v-sheet
												class="customVSheet"
												:color="$_trnCrsShtLyt_styleBodySheetColor"
												:dark="$_trnCrsShtLyt_styleBodySheetDark"
												:elevation="$_trnCrsShtLyt_styleBodySheetElevation"
												:light="$_trnCrsShtLyt_styleBodySheetLight">
											<v-card	class="customVCard"
													color="transparent"
													flat>
												<template v-if="isObject(courseVals.bigImage)">
													<v-row>
														<v-col>
															<v-img	class="customVImg"
																	:src="$_trnCrsShtLyt_styleContentBigImageUrl(courseVals)" />
														</v-col>
													</v-row>
												</template>
												<template v-if="isObject(courseVals.video)">
													<v-row>
														<v-col>
															<card-video
																	:courseKey="courseKey"
																	:contents="contents"
																	:inits="inits" />
														</v-col>
													</v-row>
												</template>
												<template v-if="isObject(courseVals.bigChart)">
													<v-row>
														<v-col>
															<card-big-chart
																	:courseKey="courseKey"
																	:contents="contents"
																	:inits="inits" />
														</v-col>
													</v-row>
												</template>
												<v-row>
													<template v-if="isObject(courseVals.image)">
														<v-col cols="12" md="4" class="center">
															<v-img	class="customVImg"
																	:src="$_trnCrsShtLyt_styleContentImageUrl(courseVals)" />
														</v-col>
													</template>
													<v-col>
														<v-row no-gutters>
															<v-col>
																<template v-if="!isFalse($_trnCrsShtLyt_langContentTitle(contentVals))">
																	<v-card-title>
																		<span v-html="$_trnCrsShtLyt_langContentTitle(courseVals)" />
																	</v-card-title>
																</template>
																<template v-if="!isFalse($_trnCrsShtLyt_langContentText(contentVals))">
																	<v-card-text>
																		<span	class="markdown"
																				v-html="marked($_trnCrsShtLyt_langContentText(courseVals))" />
																	</v-card-text>
																</template>
																<v-card-actions>
																	<v-row dense>
																		<v-col cols="auto">
																			<v-btn	class="customVBtn"

																					:disabled="!$_trnCrsShtLyt_checkCourseStatus(courseKey)"

																					:block="$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonBlock"
																					:color="$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonColor"
																					:dark="$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonDark"
																					:depressed="$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonDepressed"
																					:elevation="$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonElevation"
																					:large="$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonLarge"
																					:light="$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonLight"
																					:outlined="$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonOutlined"
																					:rounded="$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonRounded"
																					:small="$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonSmall"
																					:text="$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonFlat"
																					@click="$_trnCrsShtLyt_openCourse(courseKey)"
																					v-text="$_trnCrsShtLyt_langOpenCourse" />
																		</v-col>
																	</v-row>
																</v-card-actions>
															</v-col>
														</v-row>
													</v-col>
													<template v-if="isObject(courseVals.chart)">
														<v-col cols="12" md="6" class="center">
															<card-chart
																	:courseKey="courseKey"
																	:contents="contents"
																	:inits="inits" />
														</v-col>
													</template>
												</v-row>
											</v-card>
										</v-sheet>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</template>
				</v-col>
			</v-row>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'TrainingCourseSheetLayout',
		props: {
			contents: Object,
			inits: Object
		},
		data() {
			return {
				initialized_: false
			}
		},
		computed: {
			// current user
			$_trnCrsShtLyt_currentUserUid() {
				const self_ = this;
				return self_.getCurrentUser('uid')
			},
			// params
			$_trnCrsShtLyt_paramsCourseCode() {
				const self_ = this;
				const params_ = self_.$_training_params;
				if(self_.isFalse(params_)) { return null }
				// custom for aeon fantasy start
				return params_.courseCode || params_.courseId
				// custom for aeon fantasy end
			},
			// state
			$_trnCrsShtLyt_stateTrainings() {
				const self_ = this;
				const trainings_ = self_.getTrainingsState()
				return self_.getContentsSubset(trainings_, 'isDummy', false)
			},
			// lang
			$_trnCrsShtLyt_langOpenCourse() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'openCourse')
				return self_.getLangsVal(lang_)
			},
			// (content)
			$_trnCrsShtLyt_langContentTitle() {
				const self_ = this;
				return courseVals => {
					const title_ = courseVals.title;
					if(self_.isFalse(title_)) { return null }
					return self_.getLangsVal(title_)
				}
			},
			$_trnCrsShtLyt_langContentText() {
				const self_ = this;
				return courseVals => {
					const text_ = courseVals.text;
					if(self_.isFalse(text_)) { return null }
					return self_.getLangsVal(text_)
				}
			},
			// style
			$_trnCrsShtLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_trnCrsShtLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_trnCrsShtLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_trnCrsShtLyt_styleHeaderSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'headerSheet')
			},
			$_trnCrsShtLyt_styleHeaderSheetColor() {
				const self_ = this;
				const headerSheet_ = self_.$_trnCrsShtLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.color)
			},
			$_trnCrsShtLyt_styleHeaderSheetDark() {
				const self_ = this;
				const headerSheet_ = self_.$_trnCrsShtLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.dark)
			},
			$_trnCrsShtLyt_styleHeaderSheetElevation() {
				const self_ = this;
				const headerSheet_ = self_.$_trnCrsShtLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.elevation)
			},
			$_trnCrsShtLyt_styleHeaderSheetLight() {
				const self_ = this;
				const headerSheet_ = self_.$_trnCrsShtLyt_styleHeaderSheet;
				if(self_.isFalse(headerSheet_)) { return null }
				return self_.getStylesVal(headerSheet_.light)
			},
			$_trnCrsShtLyt_styleBodySheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'bodySheet')
			},
			$_trnCrsShtLyt_styleBodySheetColor() {
				const self_ = this;
				const bodySheet_ = self_.$_trnCrsShtLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.color)
			},
			$_trnCrsShtLyt_styleBodySheetDark() {
				const self_ = this;
				const bodySheet_ = self_.$_trnCrsShtLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.dark)
			},
			$_trnCrsShtLyt_styleBodySheetElevation() {
				const self_ = this;
				const bodySheet_ = self_.$_trnCrsShtLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.elevation)
			},
			$_trnCrsShtLyt_styleBodySheetLight() {
				const self_ = this;
				const bodySheet_ = self_.$_trnCrsShtLyt_styleBodySheet;
				if(self_.isFalse(bodySheet_)) { return null }
				return self_.getStylesVal(bodySheet_.light)
			},
			$_trnCrsShtLyt_styleCourseSheetOpenCourseButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'courseSheetOpenCourseButton')
			},
			$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonBlock() {
				const self_ = this;
				const button_ = self_.$_trnCrsShtLyt_styleCourseSheetOpenCourseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonColor() {
				const self_ = this;
				const button_ =self_.$_trnCrsShtLyt_styleCourseSheetOpenCourseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonDark() {
				const self_ = this;
				const button_ = self_.$_trnCrsShtLyt_styleCourseSheetOpenCourseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_trnCrsShtLyt_styleCourseSheetOpenCourseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonElevation() {
				const self_ = this;
				const button_ = self_.$_trnCrsShtLyt_styleCourseSheetOpenCourseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonFlat() {
				const self_ = this;
				const button_ = self_.$_trnCrsShtLyt_styleCourseSheetOpenCourseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonLarge() {
				const self_ = this;
				const button_ = self_.$_trnCrsShtLyt_styleCourseSheetOpenCourseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonLight() {
				const self_ = this;
				const button_ = self_.$_trnCrsShtLyt_styleCourseSheetOpenCourseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_trnCrsShtLyt_styleCourseSheetOpenCourseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonRounded() {
				const self_ = this;
				const button_ = self_.$_trnCrsShtLyt_styleCourseSheetOpenCourseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_trnCrsShtLyt_styleCourseSheetOpenCourseButtonSmall() {
				const self_ = this;
				const button_ = self_.$_trnCrsShtLyt_styleCourseSheetOpenCourseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			// (content)
			$_trnCrsShtLyt_styleContentBigImage() {
				return courseVals => {
					return courseVals.bigImage
				}
			},
			$_trnCrsShtLyt_styleContentBigImageUrl() {
				const self_ = this;
				return courseVals => {
					const image_ = self_.$_trnCrsShtLyt_styleContentBigImage(courseVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			},
			$_trnCrsShtLyt_styleContentImage() {
				return courseVals => {
					return courseVals.image
				}
			},
			$_trnCrsShtLyt_styleContentImageUrl() {
				const self_ = this;
				return courseVals => {
					const image_ = self_.$_trnCrsShtLyt_styleContentImage(courseVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			}
		},
		created() {
			const self_ = this;
			// user training data
			self_.$_trnCrsShtLyt_initialize()
		},
		methods: {
			$_trnCrsShtLyt_initialize() {
				const self_ = this;

				self_.initialized_ = false; 

				const uid_ = self_.$_trnSctTabLyt_currentUserUid;
				const courseCode_ = self_.$_trnCrsShtLyt_paramsCourseCode;

				Promise.resolve().then(() => {
					return self_.initializeUser('trainingData')
				}).then(result => {
					self_.initialized_ = true; 
				})
			},
			$_trnCrsShtLyt_checkCourseStatus(courseCode) {
				const self_ = this;

				const uid_ = self_.$_trnSctTabLyt_currentUserUid;
				const status_ = self_.getUserTrainingStatus(uid_, courseCode, null, null)

				let result_ = false;

				if(status_ == 'opened' || status_ == 'started' || status_ == 'finished') { result_ = true }	

				return result_
			},
			$_trnCrsShtLyt_startCourse(courseCode) {
				const self_ = this;
				const router_ = self_.$router;

				const uid_ = self_.$_trnCrsShtLyt_currentUserUid;

				Promise.resolve().then(() => {
					return self_.getTrainingStatus(uid_, courseCode, null, null)
				}).then(result => {
					if(result == 'opened') {
						return self_.updateTrainingStatus(uid_, courseCode, null, null, 'started')
					} else { return Promise.resolve() }
				}).then(() => {
					router_.push({
						name: 'training',
						params: {
							courseCode: courseCode
						}
					})
				})
			}
		}
	}
</script>

<style scoped>
</style>
